import React from "react";
import { Avatar, Typography, Box, Grid } from "@mui/material";
import color from "../../constants/color";
const styles={
  text:{
    fontWeight:"600",
    fontSize:"16px"
  },
  primary:{
    color:color.primary,
  },
  secondary:{
    color:color.text,
  },
  role:{
    color:color.lightText,
    fontSize:"12px",
    fontWeight:"400"
  },
  mainText:{
    fontSize:"18px",
    fontWeight:"600",
    mb:2
  }
}
const TopPerformance = ({ data }) => {
  const items = Array.isArray(data) && data.length > 0 ? data : [];
  return (
    <>
      <Typography sx={styles.mainText}>Top Performance Employees</Typography>

      <Grid container justifyContent="flex-start" alignItems="flex-start" justifyItems="flex-start" spacing={1}>
        {items.map((item, index) => (
          <Grid item key={index} xs={12} sm={6} md={2} lg={1.5} sx={{ display: "flex", justifyContent: "flex-start" }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", textAlign: "left", pb: 1 }}>
              <Avatar
                alt="img"
                src={item?.profile}
                variant="circular"
                sx={{ width: 96, height: 96 }}
                imgProps={{ style: { objectFit: "cover" } }}
              />
              <Box sx={{ mt: 1 }}>
                <Typography sx={styles.role}>{(item?.designation && item.designation.join(", ")) || ""}</Typography>
                <Typography variant="h6" sx={{...styles.text,...styles.secondary}}>{item?.name}</Typography>
                <Typography sx={{...styles.text,...styles.primary}}>{item?.performancePercentage ?? item?.rating ?? ""}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default TopPerformance;
